import React from "react";

export const Parentmenu = (ParentMenu) => (
    <div className="parent-menu">
        <div className="parent-menu__wrapper">
            <div className="parent-menu__wrapper__content">
                <div className="parent-menu__wrapper__content__left">
                    {
                        <a className="element-link" href={ParentMenu.HeadlineUrl}>
                            <i className="icon-left-arrow" aria-hidden="true"></i>
                            <span id="parent-menu-headline">{ParentMenu.Headline}</span>
                        </a>
                    }
                </div>
                <span
                    role="navigation"
                    aria-label={ParentMenu.AriaLabel}
                >
					<ul className="parent-menu__wrapper__content__right">
					{ParentMenu.Links.map((link, key) => (
                        <li key={`parent-menu-item-${key}`}>
                            <a className="element-link" href={link.Url} target={link.Target}>
                                <span>{link.Name}</span>
                            </a>
                        </li>
                    ))}
					</ul>
				</span>
            </div>
        </div>
    </div>
);
